import React from 'react';
import { List } from '@mui/material';
import { PostTypes } from '../../../Utils/Types';
import { canCreate } from '../../../Utils/permissions';

import PostCreationCard from '../../DesignSystem/PostCreationCard';
import { PostTypeOrSurvey } from '../../../Utils/Types/Posts';
import useSpace from '../../../Hooks/useSpace';

interface PostsCreateMenuProps {
  parentId?: string | number | null;
  postTypes: PostTypeOrSurvey[];
}

function PostsCreateMenu({ parentId, postTypes }: PostsCreateMenuProps) {
  const { space } = useSpace();

  return (
    <List>
      {postTypes.map((type) => {
        const postType = type === 'survey' ? PostTypes.STUDY : type;

        return (
          canCreate(postType, space) && (
            <PostCreationCard key={type} type={type} parentId={parentId} space={space} />
          )
        );
      })}
    </List>
  );
}

export default PostsCreateMenu;
